import { ButtonBase } from '@mui/material';
import type { OneDriveFolder } from '../../types';
import styled from '@emotion/styled';
import CannotPickItemWarning from '../utils/CannotPickItemWarning';

const FolderNameButton = styled(ButtonBase)({
  marginRight: 24,
  font: 'inherit',
  textAlign: 'left',
  ':hover, :focus': {
    textDecoration: 'underline',
  },
});

type FolderNameCellProps = {
  folder: OneDriveFolder;
  onOpenFolder: () => void;
  loading: boolean;
};

const FolderNameCell = ({
  folder,
  onOpenFolder,
  loading,
}: FolderNameCellProps) => (
  <th scope="row">
    <FolderNameButton onClick={onOpenFolder} disabled={loading}>
      {folder.name}
    </FolderNameButton>
    {!folder.webUrl && <CannotPickItemWarning variant="folder" />}
  </th>
);

export default FolderNameCell;
